import { Controller, FormProvider } from "react-hook-form";

import { FormField } from "components/form/FormField/FormField";
import { CustomInput } from "components/helpers/CustomInput/CustomInput";
import { Button } from "components/ui/Button";
import { Checkbox as CustomCheckbox } from "components/ui/Checkbox";
import { Dialog } from "components/ui/Dialog";
import { DialogFooter } from "components/ui/Dialog/DialogFooter";
import { Select } from "components/ui/Select/Select";
import { Textarea } from "components/ui/Textarea";

import { useIntoleranceForm } from "./hooks/useIntoleranceForm";
import styles from "./IntoleranceFormModal.module.css";
import { SYMPTOM_OPTIONS } from "./utils/constants";

export const IntoleranceFormModal = ({
  isOpen,
  editId,
  data,
  patientId,
  onClose,
}) => {
  const { form, isItemDisabled, handleClose, handleSubmit, isPending } =
    useIntoleranceForm({ isOpen, editId, data, patientId, onClose });

  const note = form.watch("note");

  return (
    <Dialog width={560} title="Intolerance" onClose={handleClose} open={isOpen}>
      <FormProvider {...form}>
        <form onSubmit={handleSubmit} style={{ margin: 0, marginBottom: 1 }}>
          {isItemDisabled && (
            <div className={styles.disabledBanner}>
              This intolerance has been deleted. All fields are read-only.
            </div>
          )}
          <FormField name="name" label="Name">
            <CustomInput {...form.register("name")} disabled={isItemDisabled} />
          </FormField>
          <FormField name="allergyType" label="Allergy Type">
            <CustomInput value="Intolerance" disabled />
          </FormField>
          {note !== null && (
            <FormField name="note" label="Note">
              <Controller
                name="note"
                control={form.control}
                render={({ field }) => (
                  <Textarea
                    value={field.value ?? ""}
                    onChange={field.onChange}
                    rows={3}
                    disabled={isItemDisabled}
                  />
                )}
              />
            </FormField>
          )}
          <FormField name="allergyReaction" label="Symptoms">
            <Controller
              name="allergyReaction"
              control={form.control}
              render={({ field }) => (
                <Select
                  options={SYMPTOM_OPTIONS}
                  value={field.value}
                  onChange={field.onChange}
                  disabled={isItemDisabled}
                  fullWidth
                />
              )}
            />
          </FormField>
          <div className={styles.checkboxWrapper}>
            <Controller
              name="serious"
              control={form.control}
              render={({ field }) => (
                <CustomCheckbox
                  checked={field.value ?? false}
                  handleChange={(e) => field.onChange(e.target.checked)}
                  disabled={isItemDisabled}
                />
              )}
            />
            <label className={styles.checkboxLabel}>Serious</label>
          </div>
        </form>
      </FormProvider>
      <DialogFooter>
        <Button variant="outline" onClick={handleClose}>
          {isItemDisabled ? "Close" : "Cancel"}
        </Button>
        {!isItemDisabled && (
          <Button onClick={handleSubmit} disabled={isPending}>
            {isPending ? "Saving..." : "Save"}
          </Button>
        )}
      </DialogFooter>
    </Dialog>
  );
};
